import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';

import { selectIsOrdersManager } from '../../@store/user/user.selectors';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
  private store = inject(Store);
  private router = inject(Router);
  readonly isOrdersManager = this.store.selectSignal(selectIsOrdersManager);

  canActivate(): boolean | UrlTree {
    return this.router.parseUrl(this.isOrdersManager() ? '/home/my-orders' : '/home/my-quotes');
  }
}
